export default __webpack_public_path__ + "static/media/file-document.dbda1cc3.svg";